/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { EmailApi } from './services/custom/Email';
import { RoleApi } from './services/custom/Role';
import { CertificationApi } from './services/custom/Certification';
import { ImageRecognitionApi } from './services/custom/ImageRecognition';
import { InspectionApi } from './services/custom/Inspection';
import { ClientApi } from './services/custom/Client';
import { SettingApi } from './services/custom/Setting';
import { InspectorApi } from './services/custom/Inspector';
import { HistoricalInspectionApi } from './services/custom/HistoricalInspection';
import { FeatureFlagApi } from './services/custom/FeatureFlag';
import { ClientVersionApi } from './services/custom/ClientVersion';
import { ProcedureTypeApi } from './services/custom/ProcedureType';
import { InspectionFormModuleApi } from './services/custom/InspectionFormModule';
import { AccessoryPictureApi } from './services/custom/AccessoryPicture';
import { VehiclePictureApi } from './services/custom/VehiclePicture';
import { ProvinceApi } from './services/custom/Province';
import { InspectionReportApi } from './services/custom/InspectionReport';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders<SDKBrowserModule>  {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        SDKModels,
        RealTime,
        EmailApi,
        RoleApi,
        CertificationApi,
        ImageRecognitionApi,
        InspectionApi,
        ClientApi,
        SettingApi,
        InspectorApi,
        HistoricalInspectionApi,
        FeatureFlagApi,
        ClientVersionApi,
        ProcedureTypeApi,
        InspectionFormModuleApi,
        AccessoryPictureApi,
        VehiclePictureApi,
        ProvinceApi,
        InspectionReportApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';

